import axios from '@/libs/axios'

const endpoint = '/exam-program-presentations/'

const list = ({ commit }, params = {}) => axios.get(endpoint, { params }).then(response => {
  commit('LIST', response.data)
  return response
})

const save = (ctx, item) => {
  const formData = new FormData()
  formData.append('title', item.title)
  formData.append('description', item.description)
  formData.append('status', item.status)
  formData.append('period', item.period)
  item.newFiles.forEach(file => formData.append('files', file))
  if (item.id) return axios.patch(`${endpoint}${item.id}/`, formData)
  return axios.post(endpoint, formData)
}

const remove = (ctx, id) => axios.delete(`${endpoint}${id}/`)
const removeFile = (ctx, { itemId, fileId }) => axios.delete(`${endpoint}${itemId}/files/${fileId}/`)
const exportExcel = (ctx, period) => axios.get(`${endpoint}export-excel/`, {
  params: { period },
  responseType: 'blob',
})

export default {
  list,
  save,
  remove,
  removeFile,
  exportExcel,
}
